import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppShell } from '@/components/AppShell';
import { FloorPlan } from '@/components/admin/FloorPlan';
import { useTranslation } from 'react-i18next';
export default function GuestDashboard() {
    const { t } = useTranslation();
    return (_jsxs(AppShell, { title: t('roles.GUEST'), children: [_jsx("h2", { className: "mb-4 text-lg font-semibold", children: t('tables.floorPlan') }), _jsx(FloorPlan, { canEdit: false })] }));
}
